(function () {
  'use strict';

  const STORAGE_KEY = 'shop_cookie_consent_v1';

  const GA4_MEASUREMENT_ID = 'G-CXF409TJEZ';
  const GOOGLE_ADS_ID = 'AW-XXXXXXXXXX';
  const CLARITY_ID = 'xyoadj76pa';

  const banner = document.getElementById('gdpr-cookie-banner');
  const modal = document.getElementById('gdpr-cookie-modal');
  const widget = document.getElementById('gdpr-cookie-widget');

  const analyticsInput = document.getElementById('gdpr-consent-analytics');
  const marketingInput = document.getElementById('gdpr-consent-marketing');

  const defaultConsent = {
    necessary: true,
    analytics: false,
    marketing: false,
    version: 1,
    savedAt: null,
    updatedAt: null
  };

  function getConsent() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      return null;
    }
  }

  function persistConsent(consent) {
    const existingConsent = getConsent();
    const now = new Date().toISOString();

    const finalConsent = {
      necessary: true,
      analytics: Boolean(consent.analytics),
      marketing: Boolean(consent.marketing),
      version: 1,
      savedAt: existingConsent && existingConsent.savedAt ? existingConsent.savedAt : now,
      updatedAt: now
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(finalConsent));

    updateGoogleConsentMode(finalConsent);
    syncShopifyCustomerPrivacy(finalConsent);

    hideBanner();
    closeModal();

    scheduleAllowedScripts(finalConsent);
  }

  function showBanner() {
    if (banner) banner.hidden = false;
  }

  function hideBanner() {
    if (banner) banner.hidden = true;
  }

  function openModal() {
    const consent = getConsent() || defaultConsent;

    if (analyticsInput) analyticsInput.checked = Boolean(consent.analytics);
    if (marketingInput) marketingInput.checked = Boolean(consent.marketing);

    const timestampEl = document.getElementById('gdpr-consent-timestamp');

    if (timestampEl) {
      if (consent.savedAt) {
        const date = new Date(consent.savedAt);

        timestampEl.textContent =
          'Deine letzte Cookie-Auswahl wurde gespeichert am: ' +
          date.toLocaleString('de-DE');
      } else {
        timestampEl.textContent = '';
      }
    }

    if (modal) modal.hidden = false;
  }

  window.gdprOpenModal = openModal;

  function closeModal() {
    if (modal) modal.hidden = true;
  }

  function updateGoogleConsentMode(consent) {
    window.dataLayer = window.dataLayer || [];

    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    window.gtag('consent', 'update', {
      analytics_storage: consent.analytics ? 'granted' : 'denied',
      ad_storage: consent.marketing ? 'granted' : 'denied',
      ad_user_data: consent.marketing ? 'granted' : 'denied',
      ad_personalization: consent.marketing ? 'granted' : 'denied',
      functionality_storage: 'granted',
      security_storage: 'granted'
    });
  }

  function scheduleAllowedScripts(consent) {
    if (!consent.analytics && !consent.marketing) return;

    const run = function () {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(function () {
          loadAllowedScripts(consent);
        }, { timeout: 3000 });
      } else {
        setTimeout(function () {
          loadAllowedScripts(consent);
        }, 1500);
      }
    };

    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }

  function loadAllowedScripts(consent) {
    if (consent.analytics) {
      loadGA4();
      loadMicrosoftClarity();
    }

    if (consent.marketing) {
      loadGoogleAds();
    }
  }

  function injectExternalScript(src, id) {
    if (id && document.getElementById(id)) return;

    const script = document.createElement('script');
    script.src = src;
    script.async = true;

    if (id) script.id = id;

    document.head.appendChild(script);
  }

  function injectInlineScript(code, id) {
    if (id && document.getElementById(id)) return;

    const script = document.createElement('script');
    script.text = code;

    if (id) script.id = id;

    document.head.appendChild(script);
  }

  function ensureGtagBase(id) {
    window.dataLayer = window.dataLayer || [];

    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    injectExternalScript(
      'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id),
      'gdpr-google-tag-src'
    );

    if (!window.__gdprGtagInitialized) {
      window.gtag('js', new Date());
      window.__gdprGtagInitialized = true;
    }
  }

  function loadGA4() {
    if (!GA4_MEASUREMENT_ID || GA4_MEASUREMENT_ID === 'G-XXXXXXXXXX') {
      console.warn('GA4 Measurement ID fehlt.');
      return;
    }

    ensureGtagBase(GA4_MEASUREMENT_ID);

    if (window.__gdprGA4Loaded) return;

    window.gtag('config', GA4_MEASUREMENT_ID, {
      anonymize_ip: true
    });

    window.__gdprGA4Loaded = true;
  }

  function loadGoogleAds() {
    if (!GOOGLE_ADS_ID || GOOGLE_ADS_ID === 'AW-XXXXXXXXXX') {
      console.warn('Google Ads ID fehlt.');
      return;
    }

    ensureGtagBase(GOOGLE_ADS_ID);

    if (window.__gdprGoogleAdsLoaded) return;

    window.gtag('config', GOOGLE_ADS_ID);

    window.__gdprGoogleAdsLoaded = true;
  }

  function loadMicrosoftClarity() {
    if (!CLARITY_ID || CLARITY_ID === 'XXXXXXXXXX') {
      console.warn('Microsoft Clarity ID fehlt.');
      return;
    }

    if (document.getElementById('gdpr-clarity-script')) return;

    injectInlineScript(`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);
        t.async=1;
        t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${CLARITY_ID}");
    `, 'gdpr-clarity-script');
  }

  function syncShopifyCustomerPrivacy(consent) {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return;

    try {
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: consent.analytics,
        marketing: consent.marketing,
        preferences: true,
        sale_of_data: consent.marketing
      }, function () {});
    } catch (error) {
      console.warn('Shopify Customer Privacy Sync fehlgeschlagen:', error);
    }
  }

  function bindEvents() {
    const acceptAllButton = document.getElementById('gdpr-accept-all');
    const rejectAllButton = document.getElementById('gdpr-reject-all');
    const openSettingsButton = document.getElementById('gdpr-open-settings');

    const saveSettingsButton = document.getElementById('gdpr-save-settings');
    const modalAcceptAllButton = document.getElementById('gdpr-modal-accept-all');
    const modalRejectAllButton = document.getElementById('gdpr-modal-reject-all');
    const closeModalButton = document.getElementById('gdpr-close-modal');

    if (acceptAllButton) {
      acceptAllButton.addEventListener('click', function () {
        persistConsent({
          analytics: true,
          marketing: true
        });
      });
    }

    if (rejectAllButton) {
      rejectAllButton.addEventListener('click', function () {
        persistConsent({
          analytics: false,
          marketing: false
        });
      });
    }

    if (openSettingsButton) {
      openSettingsButton.addEventListener('click', openModal);
    }

    if (saveSettingsButton) {
      saveSettingsButton.addEventListener('click', function () {
        persistConsent({
          analytics: analyticsInput ? analyticsInput.checked : false,
          marketing: marketingInput ? marketingInput.checked : false
        });
      });
    }

    if (modalAcceptAllButton) {
      modalAcceptAllButton.addEventListener('click', function () {
        persistConsent({
          analytics: true,
          marketing: true
        });
      });
    }

    if (modalRejectAllButton) {
      modalRejectAllButton.addEventListener('click', function () {
        persistConsent({
          analytics: false,
          marketing: false
        });
      });
    }

    if (closeModalButton) {
      closeModalButton.addEventListener('click', closeModal);
    }

    if (widget) {
      widget.addEventListener('click', openModal);
    }

    document.addEventListener('click', function (event) {
      if (event.target && event.target.hasAttribute('data-gdpr-close')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeModal();
      }
    });
  }

  function init() {
    bindEvents();

    const existingConsent = getConsent();

    if (!existingConsent) {
      showBanner();
      return;
    }

    updateGoogleConsentMode(existingConsent);
    syncShopifyCustomerPrivacy(existingConsent);
    scheduleAllowedScripts(existingConsent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();